export default {
  groupName: 'adpi-category-qsr',
  appName: 'QSR Category',
  baseRoute: '/dashboard/adpi-category-qsr',
  label: 'AdPi Quickview Restaurant Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'AdPi Quickview Restaurant Dashboard'
}
